import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { formatNumber } from '../../lib/format-number';

export const downloadCountUpperLimit = 999999;

export const DownloadCount: React.FC<{ count: number }> = ({ count }) => {
  const { i18n } = useTranslation();
  return (
    <>
      {count > downloadCountUpperLimit ? (
        <Trans
          i18nKey="dream:number_of_people_dreamed_01"
          values={{ count: formatNumber(downloadCountUpperLimit, i18n.language) }}
          components={{ emphasis: <em /> }}
        />
      ) : (
        <Trans
          i18nKey="dream:number_of_people_dreamed_00"
          values={{ count: formatNumber(count, i18n.language) }}
          components={{ emphasis: <em /> }}
        />
      )}
    </>
  );
};
